import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { PageTitle, Section } from 'modules';
import UploadIdentityCardButton from 'components/UploadIdentityCardButton';
import { useTranslation } from 'react-i18next';
import { WebsocketActions, WebsocketContext } from 'services/WebsocketContext';

interface UploadIdentityCardProps {
  contract: GQL.IContract;
}

const UploadIdentityCard = ({ contract }: UploadIdentityCardProps) => {
  const { t } = useTranslation();
  const [isInvalid, setIsInvalid] = useState<string[]>([]);
  const wsContext = useContext(WebsocketContext);

  const updateIsInvalid = (file: string, value = false) => {
    if (value) {
      const newIsInvalid = [...isInvalid];
      newIsInvalid.push(file);
      setIsInvalid(newIsInvalid);
    } else {
      setIsInvalid(isInvalid.filter((f) => f !== file));
    }
  };

  useEffect(() => {
    wsContext.ws?.on(WebsocketActions.REFRESH_CONTRACT_IDENTITY_CARD_FILE, (data) => {
      updateIsInvalid(data.name, true);
    });
    return () => {
      wsContext.ws?.off(WebsocketActions.REFRESH_CONTRACT_IDENTITY_CARD_FILE);
    };
  });

  return (
    <>
      {contract.client2 ? (
        <PageTitle title={t('ONLINE_FORMS.IDENTITY_CARDS')} />
      ) : (
        <PageTitle title={t('ONLINE_FORMS.IDENTITY_CARD')} />
      )}
      <span className="d-block mb-3">
        Pre úspešné realizovanie Vašej objednávky je nutné vložiť kópiu oboch strán Vášho Občianskeho preukazu
      </span>
      <Section className="mb-3">
        <Row>
          <Col>
            Občianský preukaz objednávateľa (
            <strong>
              {contract.prijmeni} {contract.jmeno}
            </strong>
            )
            <hr />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <UploadIdentityCardButton
              label="Predná strana"
              contract={contract}
              imageType={'front'}
              isInvalid={isInvalid}
              updateIsInvalid={updateIsInvalid}
            />
          </Col>
          <Col sm={6}>
            <UploadIdentityCardButton
              label="Zadná strana"
              contract={contract}
              imageType={'back'}
              isInvalid={isInvalid}
              updateIsInvalid={updateIsInvalid}
            />
          </Col>
        </Row>
      </Section>
      {contract.client2 && (
        <Section className="mb-3">
          <Row>
            <Col>
              Občianský preukaz manžela / manželky (
              <strong>
                {contract.client2.prijmeni} {contract.client2.jmeno}
              </strong>
              )
              <hr />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <UploadIdentityCardButton
                label="Predná strana"
                contract={contract}
                imageType={'front'}
                isClient2
                isInvalid={isInvalid}
                updateIsInvalid={updateIsInvalid}
              />
            </Col>
            <Col sm={6}>
              <UploadIdentityCardButton
                label="Zadná strana"
                contract={contract}
                imageType={'back'}
                isClient2
                isInvalid={isInvalid}
                updateIsInvalid={updateIsInvalid}
              />
            </Col>
          </Row>
        </Section>
      )}
    </>
  );
};

export default UploadIdentityCard;
